import Vue from 'vue/dist/vue.common';
import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-boost';
import Vue2TouchEvents from 'vue2-touch-events';

const apolloClient = new ApolloClient({
  // You should use an absolute URL here
  uri: process.env.NODE_ENV === 'development' ? 'http://artis.test/graphql' : 'https://artis-h2020.eu/graphql',
})

Vue.use(VueApollo);
Vue.use(Vue2TouchEvents, {
  disableClick: true,
  touchClass: '',
  tapTolerance: 10,
  touchHoldTolerance: 400,
  swipeTolerance: 30,
  longTapTimeInterval: 400,
  namespace: 'touch'
})

export const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})


/*
/*import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { toIdValue } from 'apollo-utilities';
// HTTP connection to the API
const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: process.env.NODE_ENV === 'development' ? 'http://artis.test/graphql' :'https://artis.istjetzt.online/graphql',
})

const cache = new InMemoryCache()

// Create the apollo client
const apolloClient = new ApolloClient({
  link: httpLink,
  cache,
})
*/